<template>
  <div class="map-legend">
    <div
      v-for="{ backgroundColor, color, label, key } in legendItems"
      :key="key"
      :style="{ backgroundColor, color }"
      class="legend-item"
    >
      {{ label }}
    </div>
  </div>
</template>

<script>
import {
  AggregateChartColors,
  CapacityCategories,
  CapacityCategoryLabels,
} from '@/store/types';

export default {
  computed: {
    legendItems() {
      return Object.entries(CapacityCategoryLabels).map(([key, label]) => ({
        backgroundColor: AggregateChartColors[key],
        color:
          key === CapacityCategories.UNDER_CAPACITY ||
          key === CapacityCategories.OVER_CAPACITY
            ? '#fff'
            : '#1b0753',
        key,
        label,
      }));
    },
  },
};
</script>

<style lang="scss" scoped>
.map-legend {
  display: flex;
  justify-content: center;
}

.legend-item {
  border-radius: 100px;
  font-size: 10px;
  font-weight: bold;
  line-height: 1.1;
  margin: 0 5px;
  padding: 7px 12px 5px;
  text-transform: capitalize;
  white-space: nowrap;
}
</style>
